import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const TooltipContainer = styled.div`
  position: relative;
  /* display: inline-block; */
  // flex: 2;
  // overflow: hidden;
  max-width: 100%;
  display: flex;
  align-items: center;
`;

export const TooltipText = styled.span`
  visibility: hidden;
  opacity: 0;
  width: ${({ config }) => config?.width || "auto"};
  height: ${({ config }) => config?.height || viewSizeCalculator(1.5)};
  background-color: ${({ config }) => config?.backgroundColor || "#333333"};
  color: ${({ config }) => config?.textColor || "#fff"};
  text-align: left;
  border-radius: ${({ config }) =>
    config?.borderRadius || viewSizeCalculator(0.625)};
  position: absolute;
  font-size: ${({ config }) => config?.fontSize || viewSizeCalculator(0.875)};
  // line-height: ${({ config }) => config?.fontSize || viewSizeCalculator(1)};
  font-weight: ${({ config }) => config?.fontWeight || "400"};
  font-family: ${({ config }) => config?.fontFamily || "Inter"};
  display: flex;
  align-items: center;
  gap: 8px;
  pointer-events: none;
  justify-content: center;
  box-shadow:
    0 0.38rem 1rem 0 rgba(0, 0, 0, 0.08),
    0 0.19rem 0.38rem -0.25rem rgba(0, 0, 0, 0.12),
    0 0.56rem 1.75rem 0.5rem rgba(0, 0, 0, 0.05);
  //   padding: 10.08px;
  padding: ${() =>
    `${viewSizeCalculator(0.5)} ${viewSizeCalculator(0.5)}`}; // 0.5rem 0.625rem
  z-index: ${({ zIndex }) => zIndex || 1000};
  transform-origin: center top;
  transition:
    transform 0.3s ease,
    opacity 0.3s ease;
  // border: 1px solid red;

  ${({ tooltipVisible }) =>
    tooltipVisible
      ? `
      transform: translateX(-50%) scale(1);
      opacity: 1;
    `
      : `
      transform: translateX(-50%) scale(0);
      opacity: 0;
    `}

  transform-origin: center top; // Ensures scale animation happens from center
  transition:
    transform 0.3s ease,
    opacity 0.3s ease;

  &::after {
    content: "";
    display: ${({ showArrow }) => (showArrow ? "block" : "none")};
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent
      ${({ config }) => config?.backgroundColor || "#fff"} transparent;
  }

  ${({ theme }) => `
    visibility: visible;
    opacity: 1;
  `}
`;

export const TooltipFloating = styled.span`
  visibility: hidden;
  opacity: 0;
  width: ${({ config }) => config?.width || "auto"};
  height: ${({ config }) => config?.height || viewSizeCalculator(1.5)};
  background-color: ${({ config }) => config?.backgroundColor || "#333333"};
  color: ${({ config }) => config?.textColor || "#fff"};
  text-align: left;
  border-radius: ${({ config }) =>
    config?.borderRadius || viewSizeCalculator(0.625)};
  position: absolute;
  font-size: ${({ config }) => config?.fontSize || viewSizeCalculator(0.875)};
  font-weight: ${({ config }) => config?.fontWeight || "400"};
  font-family: ${({ config }) => config?.fontFamily || "Inter"};
  display: flex;
  align-items: center;
  gap: 8px;
  pointer-events: none;
  justify-content: center;
  box-shadow:
    0 0.38rem 1rem 0 rgba(0, 0, 0, 0.08),
    0 0.19rem 0.38rem -0.25rem rgba(0, 0, 0, 0.12),
    0 0.56rem 1.75rem 0.5rem rgba(0, 0, 0, 0.05);
  padding: ${() =>
    `${viewSizeCalculator(0.5)} ${viewSizeCalculator(0.5)}`};
  z-index: ${({ zIndex }) => zIndex || 1000};
  transform-origin: center top;
  transition:
    transform 0.3s ease,
    opacity 0.3s ease;

  ${({ tooltipVisible }) =>
    tooltipVisible
      ? `
      transform: scale(1) !important;
      opacity: 1;
      visibility: visible;
    `
      : `
      transform: scale(0) !important;
      opacity: 0;
      visibility: hidden;
    `}

  &::after {
    content: "";
    display: ${({ showArrow }) => (showArrow ? "block" : "none")};
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent
      ${({ config }) => config?.backgroundColor || "#fff"} transparent;
  }
`;
